export interface EbaCustomField {
  label: string;
  key: string;
  checked: boolean;
  disabled: boolean;
}

export const defaultFields: EbaCustomField[] = [
  {
    label: 'Name',
    key: 'name',
    checked: true,
    disabled: true,
  },
  {
    label: 'Usage(7d)',
    key: 'usage',
    checked: true,
    disabled: false,
  },
  {
    label: 'Updated',
    key: 'update_at',
    checked: true,
    disabled: false,
  },
  {
    label: 'Description',
    key: 'description',
    checked: false,
    disabled: false,
  },
  {
    label: 'Created',
    key: 'create_at',
    checked: false,
    disabled: false,
  },
  {
    label: 'Usage(1h)',
    key: 'one_hour_usage',
    checked: false,
    disabled: false,
  },
  {
    label: 'Usage(24h)',
    key: 'twenty_four_hour_usage',
    checked: false,
    disabled: false,
  },
  {
    label: 'Usage(30d)',
    key: 'thirty_day_usage',
    checked: false,
    disabled: false,
  },
];

export const conditionJsonData = {
  conditions_all: [
    {
      title: 'Type',
      subject: 'type',
      operators: [
        {
          label: 'Is',
          value: 'is',
        },
        {
          label: 'Is not',
          value: 'is_not',
        },
      ],
      values: [
        {
          value: '004',
          label: 'Tasks',
          is_system: true,
        },
        {
          value: '003',
          label: 'Problems',
          is_system: true,
        },
        {
          value: '002',
          label: 'Incidents',
          is_system: true,
        },
        {
          value: '001',
          label: 'Questions',
          is_system: true,
        },
      ],
      is_system: false,
    },
    {
      title: 'Priority',
      subject: 'priority',
      operators: [
        {
          label: 'Is',
          value: 'is',
        },
        {
          label: 'Is not',
          value: 'is_not',
        },
        {
          label: 'Less than',
          value: 'less_than',
        },
        {
          label: 'Greater than',
          value: 'greater_than',
        },
      ],
      values: [
        {
          value: '004',
          label: 'Very High',
          is_system: true,
        },
        {
          value: '002',
          label: 'Medium',
          is_system: true,
        },
        {
          value: '003',
          label: 'High',
          is_system: true,
        },
        {
          value: '001',
          label: 'Low',
          is_system: true,
        },
      ],
      is_system: false,
    },
    {
      title: 'Status2',
      subject: 'status',
      operators: [
        {
          label: 'Is',
          value: 'is',
        },
        {
          label: 'Is not',
          value: 'is_not',
        },
        {
          label: 'Less than',
          value: 'less_than',
        },
        {
          label: 'Greater than',
          value: 'greater_than',
        },
      ],
      values: [
        {
          value: '002',
          label: 'Suspended',
          is_system: true,
        },
        {
          value: '004',
          label: 'Pending',
          is_system: true,
        },
        {
          value: '003',
          label: 'Open',
          is_system: true,
        },
        {
          value: '006',
          label: 'Closed',
          is_system: true,
        },
        {
          value: '005',
          label: 'Solved',
          is_system: true,
        },
        {
          value: '001',
          label: 'New',
          is_system: true,
        },
      ],
      is_system: false,
    },
  ],
  conditions_any: [
    {
      title: 'Type',
      subject: 'type',
      operators: [
        {
          label: 'Is',
          value: 'is',
        },
        {
          label: 'Is not',
          value: 'is_not',
        },
      ],
      values: [
        {
          value: '004',
          label: 'Tasks',
          is_system: true,
        },
        {
          value: '003',
          label: 'Problems',
          is_system: true,
        },
        {
          value: '002',
          label: 'Incidents',
          is_system: true,
        },
        {
          value: '001',
          label: 'Questions',
          is_system: true,
        },
      ],
      is_system: false,
    },
    {
      title: 'Priority',
      subject: 'priority',
      operators: [
        {
          label: 'Is',
          value: 'is',
        },
        {
          label: 'Is not',
          value: 'is_not',
        },
        {
          label: 'Less than',
          value: 'less_than',
        },
        {
          label: 'Greater than',
          value: 'greater_than',
        },
      ],
      values: [
        {
          value: '004',
          label: 'Very High',
          is_system: true,
        },
        {
          value: '002',
          label: 'Medium',
          is_system: true,
        },
        {
          value: '003',
          label: 'High',
          is_system: true,
        },
        {
          value: '001',
          label: 'Low',
          is_system: true,
        },
      ],
      is_system: false,
    },
    {
      title: 'Status2',
      subject: 'status',
      operators: [
        {
          label: 'Is',
          value: 'is',
        },
        {
          label: 'Is not',
          value: 'is_not',
        },
        {
          label: 'Less than',
          value: 'less_than',
        },
        {
          label: 'Greater than',
          value: 'greater_than',
        },
      ],
      values: [
        {
          value: '002',
          label: 'Suspended',
          is_system: true,
        },
        {
          value: '004',
          label: 'Pending',
          is_system: true,
        },
        {
          value: '003',
          label: 'Open',
          is_system: true,
        },
        {
          value: '006',
          label: 'Closed',
          is_system: true,
        },
        {
          value: '005',
          label: 'Solved',
          is_system: true,
        },
        {
          value: '001',
          label: 'New',
          is_system: true,
        },
      ],
      is_system: false,
    },
  ],
};
